import React, { useState, useEffect } from 'react';
import './MaterialenBeheer.css';
import api from '../services/api';

function InlineCel({ m, veld, type = 'text', prefix = '', onSaved }) {
  const [edit, setEdit] = React.useState(false);
  const [val, setVal] = React.useState(m[veld] ?? '');
  const [busy, setBusy] = React.useState(false);
  React.useEffect(() => { if (!edit) setVal(m[veld] ?? ''); }, [m, veld, edit]);
  const save = async () => {
    setEdit(false);
    if (String(val ?? '') === String(m[veld] ?? '')) return;
    setBusy(true);
    try {
      const r = await api.put('/materialen/' + m.id, { ...m, [veld]: val === '' ? (type === 'number' ? null : '') : val });
      onSaved(r.data.materiaal || { ...m, [veld]: val });
      if (r.data.auto_bestelling) alert(`📦 Onder minimum — automatisch bijbesteld: ${r.data.auto_bestelling.referentie}`);
    } catch (e) { alert('Opslaan mislukt'); setVal(m[veld] ?? ''); }
    finally { setBusy(false); }
  };
  if (edit) return <input autoFocus type={type} step={type === 'number' ? 'any' : undefined} value={val ?? ''} onChange={e => setVal(e.target.value)} onBlur={save}
      onKeyDown={e => { if (e.key === 'Enter') save(); if (e.key === 'Escape') { setEdit(false); setVal(m[veld] ?? ''); } }}
      style={{ width: type === 'number' ? 80 : 130, padding: '4px 6px', border: '1px solid #00D4AA', borderRadius: 4, fontSize: 13 }} />;
  const leeg = m[veld] === null || m[veld] === undefined || m[veld] === '';
  return <span onClick={() => setEdit(true)} title="Klik om te bewerken" style={{ cursor: 'text', padding: '2px 6px', borderRadius: 4, background: busy ? '#fef9c3' : 'transparent', color: leeg ? '#cbd5e1' : 'inherit', borderBottom: '1px dashed #cbd5e1' }}>
    {leeg ? '—' : (prefix + (type === 'number' ? Number(m[veld]).toString() : m[veld]))}
  </span>;
}

const MaterialenBeheer = () => {
  const [materialen, setMaterialen] = useState([]);
  const [sel, setSel] = useState([]);
  const printLabels = async (ids, alle = false) => {
    try {
      const r = await api.get('/materialen/labels', { params: alle ? { alle: 1 } : { ids: ids.join(',') }, responseType: 'text' });
      const w = window.open('', '_blank'); w.document.write(r.data); w.document.close();
    } catch (e) { alert('Labels ophalen mislukt'); }
  };
  const [loading, setLoading] = useState(true);
  const [importText, setImportText] = useState('');
  const [showImport, setShowImport] = useState(false);
  const [zoek, setZoek] = useState('');
  const [nieuwMateriaal, setNieuwMateriaal] = useState({ naam: '', code: '', categorie: '', eenheid: 'stuk', verkoopprijs: '' });
  const [showNieuw, setShowNieuw] = useState(false);
  const [editMateriaal, setEditMateriaal] = useState(null);

  useEffect(() => { loadMaterialen(); }, []);

  const loadMaterialen = async () => {
    try {
      const res = await api.get('/materialen');
      setMaterialen(res.data.materialen || []);
      setLoading(false);
    } catch (error) {
      console.error('Fout bij laden:', error);
      setLoading(false);
    }
  };

  const handleImport = async () => {
    const lines = importText.trim().split('\n').filter(l => l.trim());
    let imported = 0;
    for (const line of lines) {
      const parts = line.split(/[;\t,]/).map(p => p.trim());
      if (parts.length >= 1 && parts[0]) {
        try {
          await api.post('/materialen', {
            naam: parts[0],
            code: parts[1] || '',
            categorie: parts[2] || '',
            eenheid: parts[3] || 'stuk'
          });
          imported++;
        } catch (err) { console.error('Import fout:', err); }
      }
    }
    alert(`✅ ${imported} materialen geïmporteerd!`);
    setImportText('');
    setShowImport(false);
    loadMaterialen();
  };

  const handleNieuwOpslaan = async () => {
    if (!nieuwMateriaal.naam) { alert('Naam is verplicht'); return; }
    try {
      await api.post('/materialen', nieuwMateriaal);
      setNieuwMateriaal({ naam: '', code: '', categorie: '', eenheid: 'stuk', verkoopprijs: '' });
      setShowNieuw(false);
      loadMaterialen();
    } catch (err) { alert('Fout bij opslaan'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Materiaal verwijderen?')) return;
    try {
      await api.delete(`/materialen/${id}`);
      loadMaterialen();
    } catch (err) { alert('Fout bij verwijderen'); }
  };


const handleEdit = (m) => {
    setEditMateriaal({ ...m });
  };

  const handleEditOpslaan = async () => {
    if (!editMateriaal.naam) { alert('Naam is verplicht'); return; }
    try {
      await api.put(`/materialen/${editMateriaal.id}`, editMateriaal);
      setEditMateriaal(null);
      loadMaterialen();
    } catch (err) { alert('Fout bij opslaan'); }
  };



  const filtered = materialen.filter(m => 
    m.naam?.toLowerCase().includes(zoek.toLowerCase()) ||
    m.code?.toLowerCase().includes(zoek.toLowerCase()) ||
    m.categorie?.toLowerCase().includes(zoek.toLowerCase())
  );

  const categorien = [...new Set(materialen.map(m => m.categorie).filter(Boolean))];

  if (loading) return <div className="loading">Laden...</div>;

  return (
    <div className="materialen-beheer">
      <div className="page-header">
        <h1>📦 Materialen Beheer</h1>
        <div className="header-buttons">
          <button onClick={() => setShowNieuw(true)} className="btn-primary">+ Nieuw Materiaal</button>
        </div>
      </div>

      <div className="filters">
        <input type="text" placeholder="🔍 Zoek op naam, artikelnr of categorie..." value={zoek} onChange={e => setZoek(e.target.value)} className="search-input" />
      </div>

      <div className="table-container">
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 10 }}>
          <button className="btn-secondary" disabled={sel.length === 0} onClick={() => printLabels(sel)}>🏷️ Labels printen ({sel.length})</button>
          <button className="btn-secondary" onClick={() => printLabels([], true)}>🏷️ Alle labels</button>
          {sel.length > 0 && <button className="btn-secondary" onClick={() => setSel([])}>selectie wissen</button>}
        </div>
        <table>
          <thead>
            <tr>
              <th><input type="checkbox" checked={filtered.length > 0 && filtered.every(m => sel.includes(m.id))} onChange={e => setSel(e.target.checked ? filtered.map(m => m.id) : [])} /></th>
              <th>Artikelnummer</th>
              <th>Naam</th>
              <th>Categorie</th>
              <th>Eenheid</th>
              <th>Prijs</th>
              <th>Voorraad</th>
              <th>🚐 Bussen</th>
              <th>Totaal</th>
              <th>Min</th>
              <th>Bestel</th>
              <th>Locatie</th>
              <th>EAN</th>
              <th>Actie</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(m => (
              <tr key={m.id}>
                <td><input type="checkbox" checked={sel.includes(m.id)} onChange={e => setSel(p => e.target.checked ? [...p, m.id] : p.filter(x => x !== m.id))} /></td>
                <td><code>{m.code || '-'}</code></td>
                <td><strong>{m.naam}</strong></td>
                <td>{m.categorie || '-'}</td>
                <td>{m.eenheid}</td>
                <td><InlineCel m={m} veld="verkoopprijs" type="number" prefix="€ " onSaved={u => setMaterialen(prev => prev.map(x => x.id === u.id ? { ...x, ...u } : x))} /></td>
                <td style={{ fontWeight: 600, color: Number(m.min_voorraad) > 0 && Number(m.voorraad) < Number(m.min_voorraad) ? '#dc2626' : 'inherit' }}><InlineCel m={m} veld="voorraad" type="number" onSaved={u => setMaterialen(prev => prev.map(x => x.id === u.id ? { ...x, ...u } : x))} /></td>
                <td style={{ color: '#64748b' }}>{Number(m.in_bussen) || 0}</td>
                <td style={{ fontWeight: 700 }}>{(Number(m.voorraad) || 0) + (Number(m.in_bussen) || 0)}</td>
                <td><InlineCel m={m} veld="min_voorraad" type="number" onSaved={u => setMaterialen(prev => prev.map(x => x.id === u.id ? { ...x, ...u } : x))} /></td>
                <td><InlineCel m={m} veld="bestel_aantal" type="number" onSaved={u => setMaterialen(prev => prev.map(x => x.id === u.id ? { ...x, ...u } : x))} /></td>
                <td><InlineCel m={m} veld="voorraad_locatie" onSaved={u => setMaterialen(prev => prev.map(x => x.id === u.id ? { ...x, ...u } : x))} /></td>
                <td><InlineCel m={m} veld="ean" onSaved={u => setMaterialen(prev => prev.map(x => x.id === u.id ? { ...x, ...u } : x))} /></td>
                <td>
                  <button onClick={() => printLabels([m.id])} className="btn-edit" title="Label printen">🏷️</button>
                  <button onClick={() => handleEdit(m)} className="btn-edit">✏️</button>
                  <button onClick={() => handleDelete(m.id)} className="btn-delete">🗑️</button>
              </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan="14" className="empty-state">Geen materialen gevonden</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {showImport && (
        <div className="modal-overlay">
          <div className="modal-content large" style={{ position: "relative" }} onClick={e => e.stopPropagation()}>
            <h2>📥 Bulk Import Materialen</h2>
            <button onClick={() => setShowImport(false)} style={{ position: "absolute", top: 12, right: 14, background: "transparent", border: "none", fontSize: 24, lineHeight: 1, cursor: "pointer", color: "#94a3b8" }} title="Sluiten">×</button>
            <p style={{ color: '#6b7280', marginBottom: 16 }}>
              Plak materialen, één per regel. Formaat: <code>Naam;Artikelnummer;Categorie;Eenheid</code>
            </p>
            <textarea
              value={importText}
              onChange={e => setImportText(e.target.value)}
              placeholder="Koperen buis 15mm;KOP15;Leidingwerk;meter
Thermostaatkraan;THERM01;Kranen;stuk
PVC buis 40mm;PVC40;Afvoer;meter"
              rows={12}
              style={{ width: '100%', padding: 12, borderRadius: 8, border: '1px solid #e5e7eb', fontFamily: 'monospace', fontSize: 13 }}
            />
            <div className="modal-buttons">
              <button onClick={() => setShowImport(false)}>Annuleren</button>
              <button className="primary" onClick={handleImport}>📥 Importeren</button>
            </div>
          </div>
        </div>
      )}

      {showNieuw && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ position: "relative" }} onClick={e => e.stopPropagation()}>
            <h2>+ Nieuw Materiaal</h2>
            <button onClick={() => setShowNieuw(false)} style={{ position: "absolute", top: 12, right: 14, background: "transparent", border: "none", fontSize: 24, lineHeight: 1, cursor: "pointer", color: "#94a3b8" }} title="Sluiten">×</button>
            <div className="form-group">
              <label>Naam *</label>
              <input type="text" value={nieuwMateriaal.naam} onChange={e => setNieuwMateriaal({...nieuwMateriaal, naam: e.target.value})} placeholder="Bijv. Koperen buis 15mm" />
            </div>
            <div className="form-group">
              <label>Artikelnummer</label>
              <input type="text" value={nieuwMateriaal.code} onChange={e => setNieuwMateriaal({...nieuwMateriaal, code: e.target.value})} placeholder="Bijv. KOP15" />
            </div>
            <div className="form-group">
              <label>Categorie</label>
              <input type="text" value={nieuwMateriaal.categorie} onChange={e => setNieuwMateriaal({...nieuwMateriaal, categorie: e.target.value})} placeholder="Bijv. Leidingwerk" list="categorien" />
              <datalist id="categorien">
                {categorien.map(c => <option key={c} value={c} />)}
              </datalist>
            </div>
            <div className="form-group">
              <label>Prijs (€ per eenheid)</label>
              <input type="number" step="0.01" min="0" placeholder="0.00" value={nieuwMateriaal.verkoopprijs ?? ''} onChange={e => setNieuwMateriaal({...nieuwMateriaal, verkoopprijs: e.target.value})} />
            </div>
            <div className="form-group">
              <label>Eenheid</label>
              <select value={nieuwMateriaal.eenheid} onChange={e => setNieuwMateriaal({...nieuwMateriaal, eenheid: e.target.value})}>
                <option value="stuk">stuk</option>
                <option value="meter">meter</option>
                <option value="rol">rol</option>
                <option value="doos">doos</option>
                <option value="liter">liter</option>
                <option value="kg">kg</option>
              </select>
            </div>
            <div className="modal-buttons">
              <button onClick={() => setShowNieuw(false)}>Annuleren</button>
              <button className="primary" onClick={handleNieuwOpslaan}>💾 Opslaan</button> 
           </div> 
          </div>
        </div>
      )}
      {editMateriaal && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ position: "relative" }} onClick={e => e.stopPropagation()}>
            <h2>✏️ Materiaal Bewerken</h2>
            <button onClick={() => setEditMateriaal(null)} style={{ position: "absolute", top: 12, right: 14, background: "transparent", border: "none", fontSize: 24, lineHeight: 1, cursor: "pointer", color: "#94a3b8" }} title="Sluiten">×</button>
            <div className="form-group">
              <label>Naam *</label>
              <input type="text" value={editMateriaal.naam} onChange={e => setEditMateriaal({...editMateriaal, naam: e.target.value})} />
            </div>
            <div className="form-group">
              <label>Artikelnummer</label>
              <input type="text" value={editMateriaal.code || ''} onChange={e => setEditMateriaal({...editMateriaal, code: e.target.value})} />
            </div>
            <div className="form-group">
              <label>Categorie</label>
              <input type="text" value={editMateriaal.categorie || ''} onChange={e => setEditMateriaal({...editMateriaal, categorie: e.target.value})} list="categorien" />
            </div>
            <div className="form-group">
              <label>Prijs (€ per eenheid)</label>
              <input type="number" step="0.01" min="0" placeholder="0.00" value={editMateriaal.verkoopprijs ?? ''} onChange={e => setEditMateriaal({...editMateriaal, verkoopprijs: e.target.value})} />
            </div>
            <div className="form-group">
              <label>Eenheid</label>
              <select value={editMateriaal.eenheid} onChange={e => setEditMateriaal({...editMateriaal, eenheid: e.target.value})}>
                <option value="stuk">stuk</option>
                <option value="meter">meter</option>
                <option value="rol">rol</option>
                <option value="doos">doos</option>
                <option value="liter">liter</option>
                <option value="kg">kg</option>
              </select>
            </div>
            <div className="modal-buttons">
              <button onClick={() => setEditMateriaal(null)}>Annuleren</button>
              <button className="primary" onClick={handleEditOpslaan}>💾 Opslaan</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default MaterialenBeheer;
